import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import "./WarehouseAssortmentList.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import assortmentdetails from "../../../../assests/assortmentdetails.svg";
import assortmentRule from "../../../../assests/assortmentRule.svg";
import CircularProgress from '@mui/material/CircularProgress';
import LoadingSpinner from "../../../Loading/component";

const CohortAssortmentListComponent = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { reference_id } = useParams();
  const navigate = useNavigate();

  const filteredData =
    props.assortmentCohortMetaDataList &&
    props.assortmentCohortMetaDataList.filter((item) =>
      item.reference_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const handleWarehouseClick = (reference_id) => {
    navigate(`/home/assortment/assortmentcohortlistdetails/${reference_id}`);
  };




  return (
    <>
       {props.loading ? (
            <LoadingSpinner />
          ) : (
    <div className="warehouse-list-page">
      <Sidebar />
      <div className="warehouse-list-content">
        <div className="warehouse-list-header">
          <button className="warehouse-list-back-btn" onClick={() => navigate(-1)}>←</button>
          <h2 className="warehouse-list-title">Cohort</h2>
        </div>

        <div className="warehouse-list-search">
          <input
            type="text"
            placeholder="Search cohort by Name/ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="warehouse-list-search-input"
          />
          <SearchIcon className="warehouse-list-search-icon" />
        </div>

        <div className="warehouse-list-grid">
          {filteredData && filteredData.length > 0 ? (
            filteredData.map((item) => (
              <div
                className="warehouse-list-card"
                key={item.id}
                onClick={() => handleWarehouseClick(item.reference_id)}
              >
                <h4 className="warehouse-list-card-title">{item.reference_name}</h4>
                <div className="warehouse-list-stats">
                  <div className="warehouse-list-stat-row">
                    <div className="warehouse-list-stat-icon">
                      <img src={assortmentdetails} alt="Assortments" />
                    </div>
                    <div className="warehouse-list-stat-label">Assortments</div>
                    <div className="warehouse-list-stat-value">{item.total_assortments}</div>
                  </div>
                  <div className="warehouse-list-stat-row">
                    <div className="warehouse-list-stat-icon">
                      <img src={assortmentRule} alt="Rules" />
                    </div>
                    <div className="warehouse-list-stat-label">Rules</div>
                    <div className="warehouse-list-stat-value">{item.total_rules}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>No cohort found</p>
            </div>
          )}
        </div>
      </div>
    </div>
        )}
        </>
  );
};

export default CohortAssortmentListComponent;